/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { firestore } from "../../firebase/config";
// import ReactHTMLTableToExcel from "react-html-table-to-excel";
import "./DateRangeDonationReport.css";
import { useHistory, Link } from "react-router-dom";
import { TiArrowBack } from "react-icons/ti";

import { getDateInFormat } from "../utilities/Utils";
import GetReferenceDetails from "../GetReferenceDetails";
import ReportDetails from "./ReportDetails";

import { getDocs, doc, collection, getDoc } from "firebase/firestore";
//selector: (row) => row.donorId,
const columnData = [
  {
    name: "Donor Id",
    selector: (row) => row.donorId,
  },
  {
    name: "Donor Name",
    selector: (row) => row.fullNameWithLink,
    sortable: true,
  },
  {
    name: "Spiritual Name",
    selector: (row) => row.spiritualName,
  },
  {
    name: "PAN",
    selector: (row) => row.pan,
  },
  {
    name: "Email",
    selector: (row) => row.email,
  },
  {
    name: "Phone",
    selector: (row) => row.phone,
  },
  {
    name: "Date of Birth",
    selector: (row) => row.formatedDOB,
  },
  {
    name: "Individual Donation",
    selector: (row) => row.totalDonation,
    sortable: true,
  },
  {
    name: "Individual commitment",
    selector: (row) => row.totalCommitment,
    sortable: true,
  },
  {
    name: "Total Individual Contribution",
    selector: (row) => row.totalIndividualContribution,
    sortable: true,
  },
  {
    name: "Collection received from others",
    selector: (row) => row.totalCommitmentCollection,
    sortable: true,
  },
  {
    name: "Total collection from others",
    selector: (row) => row.totalCollectionFromOthers,
    sortable: true,
  },
  {
    name: "Reference",
    selector: (row) => row.formattedRef,
    sortable: true,
  },
];

function AllDonorDetailReport() {
  const [donorData, setDonorData] = useState(null);
  const [exportObj, setExportObject] = useState(null);
  const history = useHistory();
  const handleBackButton = (e) => {
    history.push("/donorreporthome");
    e.preventDefault();
  };

  /**
   * Retrieves the full name of a donor based on the provided reference.
   * @param {string} ref - The reference to the donor document.
   * @returns {Promise<string|null>} - A promise that resolves with the donor's full name or null if the document doesn't exist.
   */
  async function getDonorName(ref) {
    if (ref !== undefined) {
      try {
        const collectionDonor = collection(firestore, "donors");
        const docRef = doc(collectionDonor, ref);
        const snapShot = await getDoc(docRef);

        if (snapShot.exists()) {
          return snapShot.data().fullName;
        } else {
          return null; // Return null if the document doesn't exist
        }
      } catch (e) {
        console.log(`Error in AllDonorDetailReport.jsx getDonorName: ${e}`);
        console.log(`ref: ${ref}`);
        console.log(e);
        return null;
      }
    } else {
      return null;
    }
  }
  function removeAllOccurrences(inputStr, charToRemove) {
    const regex = new RegExp(charToRemove, "g");
    return inputStr.replace(regex, "");
  }

  const prepareExportObject = async (donationArray) => {
    const newArray = [];
    for (const dataObjEach of donationArray) {
      const newObj = {};
      let donorId = dataObjEach.donorId;
      let donorName = await getDonorName(donorId);

      if (donorName !== null) {
        dataObjEach.donorName = donorName;
      } else {
        return new Error(
          `AllDonorDetailReport.jsx Funcion: prepareExportObject - donorName returned null for donorId ${donorId}`
        );
      }
      if (dataObjEach.collectedByOrig !== "Self") {
        let collectedById = dataObjEach.collectedByOrig;
        let donorCollecorName = await getDonorName(collectedById);

        if (donorCollecorName !== null) {
          dataObjEach.reference = donorCollecorName;
        } else {
          return new Error(
            `AllDonorDetailReport.jsx Funcion: prepareExportObject - donorCollecorName returned null for collectedById ${collectedById}`
          );
        }
      }
      const addressStr = `${dataObjEach.address.addressLine1} ${dataObjEach.address.addressLine2} ${dataObjEach.address.city} ${dataObjEach.address.country} ${dataObjEach.address.pin}`;
      dataObjEach.fullAddress = removeAllOccurrences(addressStr, ",");

      for (const key in dataObjEach) {
        if (
          key !== "collectedByOrig" &&
          key !== "fullNameWithLink" &&
          key !== "formattedRef" &&
          key !== "address"
        ) {
          newObj[key] = dataObjEach[key];
        }
      }
      newArray.push(newObj);
    }
    setExportObject(newArray);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const querySnapShot = await getDocs(collection(firestore, "donors"));

        let donorArray = [];
        if (!querySnapShot.empty) {
          querySnapShot.forEach((donor) => {
            donorArray.push({
              donorId: donor.id,
              formatedDOB: donor.data().dob
                ? getDateInFormat(donor.data().dob.toDate().toString())
                : "",
              totalIndividualContribution:
                donor.data().totalDonation + donor.data().totalCommitment,
              totalCollectionFromOthers:
                donor.data().totalCollection +
                donor.data().totalCommitmentCollection,
              collectedByOrig: donor.data().reference,
              formattedRef:
                donor.data().reference === "Self" ? (
                  "Self"
                ) : (
                  <GetReferenceDetails
                    refId={donor.data().reference}
                    needLink={false}
                  />
                ),
              fullNameWithLink: (
                <Link to={`/donordetails/${donor.id}`}>
                  {donor.data().fullName}
                </Link>
              ),
              ...donor.data(),
            });
          });

          setDonorData(donorArray);
          prepareExportObject(donorArray);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        alert("Failed to fetch report data. Please check your network connection or permissions.");
      }
    };

    fetchData();
  }, []);
  const paginationComponentOptions = { selectAllRowsItem: true };
  return (
    <>
      <div className="card p-1 mb-1">
        <button
          className="btn btn-link"
          id="backButton"
          onClick={handleBackButton}
        >
          <TiArrowBack />
          Back to Report Home Page
        </button>
        <div className="justify-content-center d-flex">
          <h2>All Donor Report</h2>
        </div>
      </div>
      {donorData && donorData.length > 0 && (
        <div className="card border-top-0 rounded-0">
          <div className="card-body py-2 justify-content-center d-flex">
            <div>
              {/* <ReactHTMLTableToExcel
                id="table-xls-success"
                className="btn btn-info"
                table="AllDonorDetailReport"
                filename="AllDonorDetailReport"
                sheet="AllDonorDetailReport"
                buttonText="Download as XLS"
              /> */}
            </div>
          </div>
          <ReportDetails
            columns={columnData}
            data={donorData}
            keyField={"donorId"}
            pagination={true}
            paginationComponentOptions={paginationComponentOptions}
            filename="AllDonorsReport"
            exportObject={exportObj}
          />
        </div>
      )}
    </>
  );
}

export default AllDonorDetailReport;
